import React from 'react';
import { NavLink, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AppBreadcrumb from '../../Shared/AppBreadcrumb';
import UsersByCountry from './UsersByCountry';
import UsersByBadge from './UsersByBadge';

const TABS = [
    { key: 'users', icon: 'fa-globe', label: 'Utilisateurs par pays', component: UsersByCountry },
    { key: 'badges', icon: 'fa-id-badge', label: 'Utilisateurs par badge', component: UsersByBadge },
];

/** Page unique des statistiques (onglets : /stats/users, /stats/badges). */
const StatsPage = ({ match }) => {
    const { t } = useTranslation();
    const current = TABS.find((tab) => tab.key === match.params.tab);

    if (!current) return <Redirect to="/stats/users" />;

    const Content = current.component;

    return (
        <div className="container-fluid">
            <AppBreadcrumb title={t('Statistiques')} />
            <ul className="nav stats-tabs" role="tablist">
                {TABS.map((tab) => (
                    <li className="nav-item" key={tab.key}>
                        <NavLink to={`/stats/${tab.key}`} className="nav-link" activeClassName="active" role="tab">
                            <i className={`fa ${tab.icon} mr-2`} aria-hidden="true" />{t(tab.label)}
                        </NavLink>
                    </li>
                ))}
            </ul>
            <Content />
        </div>
    );
};

export default StatsPage;
